export default "__VITE_ASSET__Bv8KkvPA__"